import _ from 'lodash';

import staticData from '../../models/staticData';

export default _.transform(
  staticData.TENANT.STAGES_TRANSLATED,
  (result, value, key) => (result[`TENANT_STAGE_${key}`] = value),
  {}
);
